export function capitalizeFirstLetter (string) {
  string = string.toLowerCase()
  return string[0].toUpperCase() + string.slice(1)
}

export function convertCurrencyHTMLCodeToSymbol (text) {
  if (!text) return
  const start = text.indexOf('&#') > -1 ? text.indexOf('&#') + 2 : text.indexOf('&#')
  const end = text.indexOf(';', start)
  if ((start > -1) && (end > -1) && ((end - start) >= 2) && ((end - start) <= 5)) {
    let currencyCharCode = text.substring(start, end)
    let convertedCurrencyCharCode
    if (currencyCharCode && !isNaN(currencyCharCode)) {
      convertedCurrencyCharCode = String.fromCharCode(currencyCharCode)
    }
    if (convertedCurrencyCharCode) {
      text = text.replace(`&#${currencyCharCode};`, convertedCurrencyCharCode)
      return convertCurrencyHTMLCodeToSymbol(text)
    }
  }
  return text
}



// WEBPACK FOOTER //
// ./src/utils/helpers/StringOperations.js